import {
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILEPW_SUCCESS,
  UPDATE_PROFILEPW_FAIL,
  RESET_PROFILE_STATE,
} from "./actionTypes"

const INIT_STATE = {
  profile: [],
  editProfile: [],
  editProfilePW: [],
}

const User = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      }

    case GET_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        editProfilePW: action.payload,
        profile: action.payload.data,
      }

    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_PROFILEPW_SUCCESS:
      return {
        ...state,
        editProfilePW: action.payload,
        profile: action.payload.data,
      }

    case UPDATE_PROFILEPW_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case RESET_PROFILE_STATE:
      return {
        ...state,
        editProfile: [],
        editProfilePW: [],
        error: [],
      }
    default:
      return state
  }
}

export default User
